export const isValidEmail = (email) => {
 
  // Regular expression for email validation
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  console.log(emailRegex.test(email));
  return emailRegex.test(email);
};

// Mobile number validation function
export const isValidMobileNumber = (mobileNumber) => {
  // Regular expression for mobile number validation (basic example)
  const mobileRegex = /^[0-9]{10}$/;
  return mobileRegex.test(mobileNumber);
};

export const isValidMobileNumberWithPrefix = (mobileNumber) => {
  // Regular expression pattern for validating mobile numbers with country code
  const mobileRegex = /^\+\d{1,3}\d{10}$/;

  // Test the provided mobile number against the pattern
  return mobileRegex.test(mobileNumber);
};

export const isValidMobileNumberWithcode = (mobileNumber) => {
  console.log(mobileNumber);
  // Regular expression pattern for validating mobile numbers with country code
  const mobileRegex = /\d{1,3}\d{10}$/;

  // Test the provided mobile number against the pattern
  return mobileRegex.test(mobileNumber);
};
